var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFm = function SvgFm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6cd0ace-244c-4f98-a0f1-86f31c9f1b13a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b49bcd54-4e53-4d94-8cd8-e9f4972fb8e9b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b49bcd54-4e53-4d94-8cd8-e9f4972fb8e9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#72B1DF",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 4h-.505A.493.493 0 0 0 9 4.5c0 .268.222.5.495.5H10v.505c0 .28.224.495.5.495.268 0 .5-.222.5-.495V5h.505c.28 0 .495-.224.495-.5 0-.268-.222-.5-.495-.5H11v-.505A.493.493 0 0 0 10.5 3c-.268 0-.5.222-.5.495zm4 3h-.505a.493.493 0 0 0-.495.5c0 .268.222.5.495.5H14v.505c0 .28.224.495.5.495.268 0 .5-.222.5-.495V8h.505c.28 0 .495-.224.495-.5 0-.268-.222-.5-.495-.5H15v-.505A.493.493 0 0 0 14.5 6c-.268 0-.5.222-.5.495zm-4 3h-.505a.493.493 0 0 0-.495.5c0 .268.222.5.495.5H10v.505c0 .28.224.495.5.495.268 0 .5-.222.5-.495V11h.505c.28 0 .495-.224.495-.5 0-.268-.222-.5-.495-.5H11v-.505A.493.493 0 0 0 10.5 9c-.268 0-.5.222-.5.495zM6 7h-.505A.493.493 0 0 0 5 7.5c0 .268.222.5.495.5H6v.505c0 .28.224.495.5.495.268 0 .5-.222.5-.495V8h.505C7.785 8 8 7.776 8 7.5c0-.268-.222-.5-.495-.5H7v-.505A.493.493 0 0 0 6.5 6c-.268 0-.5.222-.5.495z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c6cd0ace-244c-4f98-a0f1-86f31c9f1b13a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgFm;